(()=>{
const init=root=>{
 if(root.dataset.nrReady)return;
 root.dataset.nrReady='true';
 const cards=[...root.querySelectorAll('[data-nr-card]')],grid=root.querySelector('.nr-grid'),more=root.querySelector('[data-nr-more]'),status=root.querySelector('[data-nr-status]'),empty=root.querySelector('[data-nr-empty]'),filters=[...root.querySelectorAll('[data-nr-rating]')];
 let selected='all',limit=6,frame=0;
 const layout=()=>{
  if(!root.getClientRects().length)return;
  grid.classList.add('nr-masonry');
  const style=getComputedStyle(grid),row=parseFloat(style.gridAutoRows)||8,gap=parseFloat(style.rowGap)||12;
  cards.filter(card=>!card.hidden).forEach(card=>{card.style.gridRowEnd='span '+Math.ceil((card.firstElementChild.getBoundingClientRect().height+gap)/(row+gap))});
 };
 const queue=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(layout)};
 const update=(focusNew=false)=>{
  const matching=cards.filter(card=>selected==='all'||card.dataset.rating===selected),visible=matching.slice(0,limit),previous=cards.filter(card=>!card.hidden).length;
  cards.forEach(card=>{card.hidden=!visible.includes(card)});
  filters.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.nrRating===selected)));
  status.textContent=(matching.length===1?root.dataset.statusSingle:root.dataset.statusTemplate).replace('__shown__',String(visible.length)).replace('__total__',String(matching.length));
  more.hidden=visible.length>=matching.length;empty.hidden=matching.length!==0;queue();
  if(focusNew&&matching[previous])matching[previous].focus({preventScroll:true});
 };
 filters.forEach(button=>button.addEventListener('click',()=>{selected=button.dataset.nrRating;limit=6;update()}));
 more.addEventListener('click',()=>{limit+=6;update(true)});
 if('ResizeObserver'in window){const observer=new ResizeObserver(queue);cards.forEach(card=>observer.observe(card.firstElementChild));observer.observe(root)}
 root.querySelectorAll('img').forEach(img=>img.addEventListener('load',queue));
 addEventListener('resize',queue);addEventListener('hashchange',queue);
 update();
};
const boot=()=>document.querySelectorAll('[data-nudelo-reviews]').forEach(init);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
document.addEventListener('shopify:section:load',boot);
})();
